import { render, staticRenderFns } from "./InteractionOfScale.vue?vue&type=template&id=2b66d6ed&scoped=true&"
import script from "./InteractionOfScale.vue?vue&type=script&lang=js&"
export * from "./InteractionOfScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b66d6ed",
  null
  
)

export default component.exports